import { render } from "./AppText.vue?vue&type=template&id=7fe778c4&scoped=true&ts=true"
import script from "./AppText.vue?vue&type=script&lang=ts"
export * from "./AppText.vue?vue&type=script&lang=ts"

import "./AppText.vue?vue&type=style&index=0&id=7fe778c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe778c4"]])

export default __exports__